const notEmpty = (data) => {
  return data.value.trim() !== '';
};

export default notEmpty;
